import React from 'react';
import DocumentLibrary from '@/app/pages/documentlibrary';
import AuditorContextProvider from '../components/AuditorContextProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Auditor Document Library component
 * 
 * Renders a read-only version of the Document Library page for auditor view
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorDocumentLibrary: React.FC = () => {
  const navigate = useNavigate();

  // Create a navigation handler for back button
  const handleBackNavigation = () => {
    // Navigate to auditor dashboard or another appropriate location
    navigate('/auditor-view');
  };

  return (
    <AuditorContextProvider>
      {/* Pass isReadOnly={true} to document library to ensure read-only mode */}
      <DocumentLibrary 
        isReadOnly={true}
        onBackNavigation={handleBackNavigation} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorDocumentLibrary;